module.exports = __webpack_public_path__ + "static/media/vcu-mobile.c9d3c8df.png";


//////////////////
// WEBPACK FOOTER
// ./src/vcu-mobile.png
// module id = 242
// module chunks = 0